/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet } from 'react-native';

function RoundedContent({ children, style, border, ...otherProps }) {
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default RoundedContent;
